export default {
  GET_STATISTICS_REQUEST: 'GET_STATISTICS_REQUEST',
  GET_STATISTICS_REQUEST_SUCCESS: 'GET_STATISTICS_REQUEST_SUCCESS',
  GET_STATISTICS_REQUEST_FAIL: 'GET_STATISTICS_REQUEST_FAIL',
}
